import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {fee as feeAction} from 'actions'
import {SETTING} from 'constants'
import useUserLoginStatus from './useUserLoginStatus'
import useOpenFutureStatus from './useOpenFutureStatus'

export default function useFeeDataProvider (symbol) {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const ifOpenFuture = useOpenFutureStatus()
  const setData = useCallback(async () => {
    const ASSET = 'BNB'
    let balances = {}
    let feeInfo = {}

    try {
      const balanceRes = await ApiSdk.futures.getBalance({asset: ASSET})
      const feeRes = await ApiSdk.futures.getFeeInfo(symbol)

      balances = balanceRes?.balances || {}
      feeInfo = feeRes?.data || {}
      // eslint-disable-next-line no-empty
    } catch {}

    dispatch(
      feeAction({
        ...feeInfo,
        hasBNB: !!balances[ASSET]?.walletBalance
      })
    )
  }, [dispatch, symbol])

  useEffect(() => {
    const {feeAvailable} = SETTING
    if (!isLogin || !feeAvailable) return
    if (!ifOpenFuture) return
    setData()
  }, [dispatch, isLogin, setData, ifOpenFuture])
}
